/**
 * Notifications and Communication-related GraphQL queries
 * Notifications, SMS templates, and communication features
 */

export const NOTIFICATIONS_QUERIES = {
  // Notifications queries
  GET_TRANSFER_PATIENT_NOTIFICATIONS: `
    query GetTransferPatientNotifications {
      pep_vw_patient_user_transfer {
        transfer_id
        enrollment_patient_id
        patient_name
        clinic_id
        clinic_name
        assigned_by_user_id
        assigned_by_user_name
        assigned_to_user
        assigned_to_user_name
        assigned_dt
      }
    }
  `,

  // Notifications subscription
  SUBSCRIBE_TRANSFER_PATIENT_NOTIFICATIONS: `
    subscription SubscribeTransferPatientNotifications {
      pep_vw_patient_user_transfer {
        transfer_id
        enrollment_patient_id
        patient_name
        clinic_id
        clinic_name
        assigned_by_user_id
        assigned_by_user_name
        assigned_to_user
        assigned_to_user_name
        assigned_dt
      }
    }
  `,

  // Transfer Patient Subscription
  TRANSFER_PATIENT_SUBSCRIPTION: `
    subscription TransferPatientUpdates($transferId: Int!) {
      pep_vw_transfer_patient_list(where: {id: {_eq: $transferId}, assigned_cs_id: {_is_null: false}}) {
        id
        care_specialist
      }
    }
  `,

  // SMS Templates query
  GET_SMS_TEMPLATES: `
    query MyQuery {
      api_sms_template(where: {is_deleted: {_eq: false}, template_key: {_ilike: "PEP"}}) {
        is_active
        template
        template_id
        template_key
        template_name
      }
    }
  `
};